import Hero from '@/sections/Hero';
import DualEntry from '@/sections/DualEntry';
import Spotlight from '@/sections/Spotlight';
import Instruments from '@/sections/Instruments';
import News from '@/sections/News';
import DomainSummary from '@/sections/DomainSummary';
import Services from '@/sections/Services';
import Trust from '@/sections/Trust';
import Clients from '@/sections/Clients';
import Cases from '@/sections/Cases';
import CompanyTeaser from '@/sections/CompanyTeaser';
import Location from '@/sections/Location';

// 홈 메인 페이지 — evs.com/as 섹션 순서. (라우팅 도입 전 App.tsx 본문을 그대로 이관)
// [2026-10-23 사용자] UI/UX 갱신 공지는 전역(App.tsx <UpdateNotice/>)으로 이동 → 모든 페이지 노출.
export default function Home() {
  return (
    <main>
      <Hero />
      {/* 이중 진입(D안 Phase 2-①) — Hero 아래 신규. 제품 축 / 안전·환경 축 */}
      <DualEntry />
      {/* ── D안 홈 순서(Phase 2-②, 2026-09): 제품 최우선 → 실적·신뢰 → 도메인 요약 → 뉴스 → 오시는 길 ──
          회사소개는 후순위(홈에선 최소, 상단 메뉴 맨끝). 안전/환경 도메인 요약은 Phase 4 신규 예정. */}

      {/* ① 주력 제품 · 계측기 (제품 최우선). 제품소개 캐러셀은 계측기 그리드와 중복이라 제거(2026-09 사용자 승인) */}
      <Spotlight />
      <Instruments />

      {/* ② 실적 · 신뢰 (설치사례 · 주요거래처 · 인증) */}
      <Cases />
      <Clients />
      <Trust />

      {/* 안전/환경 도메인 요약(D안 Phase 2-④) — evs.com Market Applications식 하이라이트, /safety·/environment 진입(Phase3) */}
      <DomainSummary />

      {/* 마무리·전환 흐름(2026-09-06 사용자 교정): 뉴스 → 회사소개(짧게) → ★고객지원(상담·문의) → 오시는 길.
          근거: 사용자가 페이지를 위→아래로 다 훑은 뒤 '상담/contact'하는 단계라 고객지원은 오시는 길 바로 위가 실무적으로 맞음.
          (기존엔 Services=고객지원이 실적·신뢰 블록 안에 있었음 → 여기로 이동.) D융합안에도 반영. */}
      <News />
      <CompanyTeaser />
      <Services />
      <Location />
    </main>
  );
}
